import React from 'react';
import { useCmsContext } from '@gjensidige/service-cms';

import { CheckListItems } from '../../types';
import { Step } from '../../types/enums';
import { useCheckListContext } from '../../context/CheckListProvider';
import Checkmark from './Checkmark';
import styles from './Steps.module.scss';

interface StepsProps {
  checkList: CheckListItems;
  onItemClick: (step: Step) => void;
}

const StepsMobileNav = ({ checkList, onItemClick }: StepsProps) => {
  const { getText } = useCmsContext();
  const { answers } = useCheckListContext();

  return (
    <ul className={styles.steps}>
      {Object.keys(checkList).map((k) => {
        const key = parseInt(k);
        const { texts } = checkList[key];
        const title = getText(`${texts}.modal.title`);
        return (
          <li
            className={styles.step}
            key={key}
            onClick={() => onItemClick(key)}
          >
            <Checkmark
              value={answers[key as Step]}
              className={styles.stepIcon}
            />
            {title}
          </li>
        );
      })}
    </ul>
  );
};

export default StepsMobileNav;
